import Footer from "../../../../components/footer";
import React, { useState, useEffect, useRef } from "react";
import "./passwordResetClient.css";
import { useNavigate, useLocation } from "react-router-dom";
import HomeHeader from "../homeHeader";
import { supabase } from "../../../../supabaseClient";

const PasswordResetClient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [secondsLeft, setSecondsLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const timerRef = useRef(null);

  // helper to send the reset email
  const sendResetEmail = async () => {
    if (!email) {
      navigate("/");
      return;
    }

    // point users back at your own reset-password route:
    const redirectUrl = `${window.location.origin}/auth/update-password`;

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectUrl,
    });

    if (error) {
      console.error("Error sending password reset:", error.message);
      // show an in‑UI error/toast here if you like
    } else {
      console.log("Password reset email sent to", email);
      // now the email they receive will contain a link to:
      //   https://yourdomain.com/grow/reset-password?access_token=...&type=...
    }
  };

  // kick off on mount
  useEffect(() => {
    sendResetEmail();

    // start countdown
    setCanResend(false);
    setSecondsLeft(60);

    timerRef.current = setInterval(() => {
      setSecondsLeft((secs) => {
        if (secs <= 1) {
          clearInterval(timerRef.current);
          setCanResend(true);
          return 0;
        }
        return secs - 1;
      });
    }, 1000);

    // cleanup on unmount
    return () => clearInterval(timerRef.current);
  }, []);

  const handleResendEmail = async (e) => {
    e.preventDefault();
    if (!canResend) return;

    // 1) immediately disable further clicks
    setCanResend(false);
    setSecondsLeft(60);
    clearInterval(timerRef.current);

    // 2) restart the countdown
    timerRef.current = setInterval(() => {
      setSecondsLeft((secs) => {
        if (secs <= 1) {
          clearInterval(timerRef.current);
          setCanResend(true);
          return 0;
        }
        return secs - 1;
      });
    }, 1000);

    // 3) now fire the email off (in the “background”)
    try {
      await sendResetEmail();
    } catch (err) {
      console.error(err);
      // optionally show an error toast/etc
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <HomeHeader title="" isTitle={false} headerColor="header-white" />
      <div className="request-email-container">
        <div className="request-email-form-wrapper">
          <h2 className="request-email-heading">Password Reset Email Sent</h2>
          <h3 className="request-email-subtitle">
            If a Quidpro account exists with <strong>{email}</strong>,
            <br /> you will receive an email shortly.
          </h3>

          <h3 className="request-email-subtitle">
            Didn't receive an email?{" "}
            <button
              type="button"
              className="password-try-again"
              disabled={!canResend}
              onClick={handleResendEmail}
            >
              {canResend ? "Try again" : `Try again in ${secondsLeft}s`}
            </button>
          </h3>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PasswordResetClient;
